import moment, { Moment } from 'moment';

// https://dhigroup.visualstudio.com/DHI-DK-POT/_workitems/edit/144760/
// Remove after date range will be fulfilled with data

const BLOCKED_DWF_SPECTRA_DATASET_ID = 'waterdata-dataset-DWF23_SW_WRF';
const LAST_AVAILABLE_SPECTRA_DATE_FOR_DWF = '31.12.2023';

export const DWF_SPECTRA_UNAVAILABLE_MESSAGE = 'Wave spectra is not available for this time range';

export const useTemporaryDWFSpectraBlocker = (
  datasetId?: string,
  endDate?: Moment | string | Date | null
) => {
  const isBlockedDataset = datasetId === BLOCKED_DWF_SPECTRA_DATASET_ID;

  const parsedEndDate = endDate ? (moment.isMoment(endDate) ? endDate : moment(endDate)) : null;

  const isSpectraBlocked = Boolean(
    isBlockedDataset &&
      parsedEndDate?.isValid() &&
      parsedEndDate.isAfter(moment(LAST_AVAILABLE_SPECTRA_DATE_FOR_DWF, 'DD.MM.YYYY'), 'day')
  );

  return {
    isSpectraBlocked,
    spectraBlockedMessage: DWF_SPECTRA_UNAVAILABLE_MESSAGE,
  };
};
